import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Captcha = ({ onValidate }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  const [code] = useState(() => Math.random().toString(36).substring(2, 8));

  const normalizeValue = (value = '') => value.trim().toLowerCase();

  const handleChange = e => {
    const value = e.target.value;
    setInput(value);
    onValidate(normalizeValue(value) === normalizeValue(code));
  };

  return (
    <div className="mb-2">
      <label className="block text-xs font-medium text-gray-700 mb-1">{t('common.captchaLabel')}: <span className="font-mono bg-gray-200 px-2 py-0.5 rounded">{code}</span></label>
      <input type="text" value={input} onChange={handleChange} className="input w-full" placeholder={t('common.enterCodeAbove')} />
    </div>
  );
};

export default Captcha;
